// extracted by mini-css-extract-plugin
module.exports = {"container":"PayoutCard_container_2V04X","title":"PayoutCard_title_3dK13","text":"PayoutCard_text_uk7Bb"};